"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loudspeaker: {
    remindText: 'Rappelle moi plus tard',
    dismissText: 'Bien reçu, merci!',
    viewAllAnnouncementsText: 'Cliquez ici pour voir toutes les annonces',
    readMoreAllAnnouncementsLink: 'Lire la suite'
  }
};
exports.default = _default;